import React from 'react'
import Typeform from '../components/Typeform'
const EnterpriseTypeform: React.FC<{}> = () => (
  <Typeform
    url="https://iterative-ai.typeform.com/to/xGTxcID7"
    title="Enterprise Form"
  />
)

export default EnterpriseTypeform
